<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre_completo" class="block text-sm font-medium text-gray-700">Nombre completo</label>
      <input type="text" id="nombre_completo" :value="loadData.nombre_completo"
             @change="(nombreCompletoNew)=>$emit('updateValues', {'nombre_completo': nombreCompletoNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="usuario" class="block text-sm font-medium text-gray-700">Usuario</label>
      <input type="text" id="usuario" :value="loadData.usuario"
             @change="(usuarioNew)=>$emit('updateValues', {'usuario': usuarioNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="email" class="block text-sm font-medium text-gray-700">Correo</label>
      <input type="email" id="email" :value="loadData.email"
             @change="(emailNew)=>$emit('updateValues', {'email': emailNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div v-if="parentView === 'crear'" class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="password" class="block text-sm font-medium text-gray-700">Contraseña</label>
      <input type="password" id="password" :value="loadData.password"
             @change="(passwordNew)=>$emit('updateValues', {'password': passwordNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="rol_id" class="block text-sm font-medium text-gray-700">Rol</label>
      <select id="rol_id" :value="loadData.rol_id"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(rolIdNew)=>$emit('updateValues', {'rol_id': rolIdNew.target.value})">
        <option value="" selected>Seleccione un rol...</option>
        <option v-for="(rol, index) of collectionRoles" :key="'B'+index"
                :value="rol.id">{{
            rol.nombre
          }}
        </option>
      </select>
    </div>
    <p v-if="loadDataPermisosAdicionales.length" class="col-span-6 text-lg">
      <span class="font-semibold text-gray-700 mr-3"
      >Permisos adicionales:</span
      >
    </p>
    <div class="flex flex-wrap col-span-6 gap-6">
      <label v-for="(checkbox, index) of loadDataPermisosAdicionales"
             :for="'permiso' + index"
             :key="index"
             class="flex items-center grow px-4 border border-gray-200 rounded dark:border-gray-700">
        <input
            :checked="loadDataPermisosAdicionales[index].checked"
            @change="()=>$emit('updateLoadDataPermisosAdicionales', index)"
            :value="checkbox.permiso.id"
            :id="'permiso' + index"
            type="checkbox"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        />
        <div class="py-4 ml-2 break-all text-sm font-medium text-gray-900 dark:text-gray-300">
          {{ checkbox.permiso.nombre }}
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import {ref} from "vue";
import {useAPIRest} from "@/common/constants";

/**
 * Componente con el formulario para crear o actualizar un usuario
 * @vue-data {Array} [collectionRoles=[]] - Lista de todos los roles.
 * @vue-prop {Object} loadData - Los datos presentes en el formulario.
 * @vue-prop {Array} loadDataPermisosAdicionales - La lista de permisos adicionales con su respectivo estado.
 * @vue-prop {String} parentView - La vista del componente padre.
 * @vue-prop {String} authToken - El token de autorización.
 * @vue-event {Object} updateValues - Emite un objeto para actualizar una propiedad del componente padre.
 * @vue-event {number} updateLoadDataPermisosAdicionales - Emite el índice de un checkbox cuyo estado ha cambiado
 */
export default {
  name: 'UsuariosCrearActualizarComponent',

  props: {
    loadData: Object,
    loadDataPermisosAdicionales: Array,
    parentView: String,
    authToken: String,
  },
  emits: ["updateValues", "updateLoadDataPermisosAdicionales"],
  async setup(props) {
    const collectionRoles = ref([]);
    collectionRoles.value = await useAPIRest(process.env.VUE_APP_NEST_ROL_FINDALL, 'GET', props.authToken, undefined, {
      page: 1,
      orderBy: 'created_at',
      order: 'ASC',
      criterion: '',
      search: '',
      where: '',
      isPaginate: false
    });
    return {
      collectionRoles
    }
  },
}
</script>